import React, { useEffect, useRef } from 'react';
import { useField } from 'formik';
import styles from "layout/Auth/Auth.module.scss";

const AppInputField = ({ fieldType, label, onInputChange, errorStyles = {}, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;
  const timeInputRef = useRef(null);
  const type = props.type

  const handleInputClick = () => {
    if (timeInputRef.current && (type && (type == "time" || type == "date"))) {
      timeInputRef.current.showPicker();
    }
  };

  useEffect(() => {
    const value = typeof field?.value?.trimLeft === "function" ? field?.value?.trimLeft() : field?.value;
    typeof onInputChange == "function" && onInputChange(value || "");
    setValue(value);

  }, [field.value, setValue]);

  return (
    <>
      <div className="w-100">

        {fieldType === "textarea" ? (
          <textarea
            {...field}
            {...props}
          ></textarea>
        ) : (
          <input
            {...field}
            {...props}
            ref={timeInputRef}
            onClick={handleInputClick}
            autoComplete='off'

          />
        )}
        {meta.touched && meta.error ? (
          <div className="error" style={{ ...errorStyles }}>{meta.error}</div>
        ) : null}
      </div>
    </>
  );
};

export default AppInputField;